import { ListType } from './PhxListNode';

const LIST_TYPES = ['number', 'alpha', 'bullet', 'check', 'legacy_number', 'legacy_alpha'] as const;
type ListTypeUnion = typeof LIST_TYPES[number];

export const listStyles: Record<ListTypeUnion, string[]> = {
  bullet: ['square', 'circle'],
  number: ['decimal', 'lower-alpha', 'lower-roman'],
  alpha: ['upper-alpha', 'lower-alpha', 'lower-roman'],
  legacy_number: ['decimal', 'lower-alpha'],
  legacy_alpha: ['lower-alpha', 'decimal'],
  check: ['none'],
};

export const listTypeToStyle: Record<ListTypeUnion, string> = {
  number: 'decimal',
  alpha: 'lower-alpha',
  bullet: 'disc',
  check: 'none',
  legacy_number: 'decimal',
  legacy_alpha: 'lower-alpha',
};

export const isValidListType = (type: string): type is ListTypeUnion => {
  return LIST_TYPES.includes(type as ListTypeUnion);
};

export const getListMarker = (type: ListTypeUnion, level: number): string => {
  const markers = listStyles[type] || listStyles.bullet;
  return markers[level % markers.length];
}; 